"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
var BaseIcon = function (_a) {
    var _b;
    var src = _a.src, _c = _a.fontSize, fontSize = _c === void 0 ? 'inherit' : _c, _d = _a.color, color = _d === void 0 ? 'inherit' : _d, className = _a.className, _e = _a.onClick, onClick = _e === void 0 ? function () { return null; } : _e;
    var handleClick = function (event) {
        if (onClick) {
            onClick(event);
        }
    };
    return (react_1.default.createElement("span", { className: classnames_1.default('icon', className), onClick: handleClick, "aria-hidden": "true" },
        react_1.default.createElement(react_inlinesvg_1.default, { className: classnames_1.default('icon-root', (_b = {},
                _b["icon-font-size-" + fontSize] = fontSize !== 'inherit',
                _b["icon-color-" + color] = color !== 'inherit',
                _b)), src: src, preProcessor: function (code) {
                return color === 'original'
                    ? code
                    : code.replace(/fill=".*?"/g, 'fill="currentColor"').replace(/fill:.*?;/g, 'fill:currentColor;');
            } })));
};
exports.default = BaseIcon;
//# sourceMappingURL=BaseIcon.js.map